import prettyBytes from 'pretty-bytes';
import { Fragment, memo } from 'react';

export type FormattedFileSizeProps = {
  value: number;
};

export const FormattedFileSizeBase = ({ value }: FormattedFileSizeProps) => (
  <Fragment>{prettyBytes(value)}</Fragment>
);

FormattedFileSizeBase.displayName = 'FormattedFileSize';

export const FormattedFileSize = memo(FormattedFileSizeBase);
